import * as React from 'react';
import { Grid, Col, Row } from 'react-flexbox-grid';
import { compose, withProps, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm, change } from 'redux-form';
import * as moment from 'moment';

import Button from '@inqool/uas-web-core/es/components/controls/Button';

import { InputField, Input, DateField, Date, InlineGridField, InlineGrid } from '@components/form';
import { Loader } from '@components/loader';
import { required } from '@utils/validators';
import { eventsAudioRecordsColumns } from './_eventsColumns';
import { DATE_FORMAT } from '@utils/utils';

const enhance = compose<any, any>(
  connect<any, any, any>(
    state => ({
      reportPhone: formValueSelector('module-events')(state, 'report.externalReporter.phone')
    }),
    dispatch => ({
      setAudioRecords: value => dispatch(change('module-events-record', 'records', value))
    })
  ),
  withProps(({ reportPhone }) => ({
    initialValues: {
      phone: reportPhone,
      from: moment()
        .subtract(1, 'weeks')
        .format(DATE_FORMAT),
      to: moment().format(DATE_FORMAT)
    }
  })),
  withState('loader', 'setLoader', false),
  withState('page', 'setPage', -1),
  withState('records', 'setRecords', []),
  reduxForm({ form: 'module-events-record' }),
  withHandlers({
    onSubmit: ({
      setLoader,
      setPage,
      setAudioRecords,
      setRecords,
      records: oldRecords,
      pbx,
      getAudioRecordsNotify
    }) => page => async ({ records, ...formData }) => {
      setLoader(true);
      const result = await getAudioRecordsNotify(pbx, { page, ...formData });
      const { data, pageNext } = result;
      const newReport = [...(page === 1 ? [] : oldRecords), ...data];

      setPage(pageNext);
      setAudioRecords(newReport);
      setRecords(newReport);
      setLoader(false);
    }
  })
);

const View: React.SFC<any> = ({
  loader,
  handleSubmit,
  onSubmit,
  closeItem,
  page,
  pbx,
  eventId,
  saveAudioRecordNotify
}) => {
  return (
    <div>
      {loader && <Loader />}
      <form className="layout" onSubmit={handleSubmit}>
        <Grid fluid={true}>
          <Row>
            <Col md={12}>
              <h4>Audio záznamy</h4>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <InputField component={Input} label={'Telefon *'} name={'phone'} validate={[required]} />
            </Col>
            {[
              { name: 'from', label: 'Datum a čas od *', allowFuture: false },
              { name: 'to', label: 'Datum a čas do *', allowFuture: true }
            ].map(({ name, label, allowFuture }) => (
              <Col md={4} key={name}>
                <DateField
                  component={Date}
                  label={label}
                  name={name}
                  dateOnly={true}
                  validate={[required]}
                  allowFuture={allowFuture}
                />
              </Col>
            ))}
          </Row>
          <Button label="Vyhledat" primary={true} style={{ margin: '16px 0' }} onClick={handleSubmit(onSubmit(1))} />
          <Row className="without-min-width">
            <Col md={12}>
              <InlineGridField
                component={InlineGrid}
                style={{ maxHeight: '300px' }}
                name="records"
                ignoreLocalStorage={true}
                columns={eventsAudioRecordsColumns({ eventId, saveAudioRecordNotify, pbx })}
                showCheckboxes={false}
                deleting={false}
                adding={false}
                editing={false}
                filtering={false}
              />
            </Col>
            <Col md={12} style={{ width: '100%', display: 'flex', justifyContent: 'space-between', margin: '16px 0' }}>
              <Button
                label="Načíst další data"
                primary={true}
                disabled={page === -1}
                onClick={handleSubmit(onSubmit(page))}
              />
              <Button label="Zavřít" onClick={closeItem} />
            </Col>
          </Row>
        </Grid>
      </form>
    </div>
  );
};

export const EventsAudioRecordModal = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsAudioRecordModal.tsx